import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux'
import { RootState } from '../../reducer';
import { LinearProgress, Tabs } from '../../tailwindcomponents';
import taskApi from './../../api/tasks';
import lineApi from './../../api/line';
import { FlightSchedule } from '../../types/line';
import FlightScheduleView from './FlightSchedule';
import LiteHandover from './LiteHandover';
import { useQueryTab } from '../../utils/usePersistedTab';
import { sortRowsByKey } from '../../utils/tableSort';

function Lite() {
    const [allTails, setAllTails] = useState(Array<string>());
    const { tabValue, setTabValue } = useQueryTab("tab", 0);
    const [FlightScheduleObj, setFlightSchedule] = useState(Array<FlightSchedule>());
    const [data_fetched_when, set_data_fetched_when] = useState("");
    const [loading, setLoading] = useState(false);
    const store = useSelector((state: RootState) => state);
    const isLineSupervisorAdmin = store.user.me.user_clearence_groups.includes("Line Supervisor Edit");

    useEffect(() => {
        taskApi.GetAllTailNumbers().then(res => {
            setAllTails(res.data);
        });
        refresh();
    }, []);

    const refresh = () => {
        setLoading(true);
        lineApi.getFlightSchedule().then(res => {
            setLoading(false);
            setFlightSchedule(sortRowsByKey(res.data, 'arrivalTime', 'asc'));
            set_data_fetched_when(res.data_fetched_when);
        });
    }

    return (
        <div>
            {loading && <LinearProgress />}
            < Tabs
                tabNames={["Supervisor Handover", "Flight schedule"]}
                onChangeTabValue={(tabValue: number) => setTabValue(tabValue)}
                tabValue={tabValue}
            />
            {tabValue === 0 && < LiteHandover setLoading={setLoading} allTails={allTails} workPlace={"LITE"} />}
            {tabValue === 1 && < FlightScheduleView refresh={() => refresh()} flights={FlightScheduleObj} dataFetched={data_fetched_when}
                isLineSupervisorAdmin={isLineSupervisorAdmin}
            />
            }
        </div>
    );
};
export default Lite;
